<template>
  <b-modal
    id="createDoc"
    hide-footer
    no-close-on-backdrop
    @show="resetForm"
    modal-class="modern-modal"
    size="lg"
  >
    <template v-slot:modal-title>
      <div class="modal-title-modern">
        <i class="fas fa-file-upload mr-2"></i>
        Adicionar Arquivo
      </div>
    </template>

    <div class="modal-content-modern">
      <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
        <form @submit="createDoc" class="upload-form">
          <!-- File Upload Section -->
          <div class="form-section">
            <div class="section-header">
              <h4 class="section-title">
                <i class="fas fa-cloud-upload-alt mr-2"></i>
                Seleção do Arquivo
              </h4>
            </div>

            <div class="upload-area">
              <div class="file-input-container">
                <label for="doc" class="file-input-label">
                  <div class="upload-icon">
                    <i class="fas fa-file"></i>
                  </div>
                  <div class="upload-text">
                    <span class="upload-title"
                      >Clique para selecionar o arquivo</span
                    >
                    <span class="upload-subtitle">ou arraste e solte aqui</span>
                  </div>
                </label>
                <input
                  id="doc"
                  type="file"
                  class="file-input"
                  accept=".pdf,.jpg,.jpeg,.png"
                  multiple
                  @change="onFileChange"
                />
              </div>

              <div v-if="selectedFileName" class="selected-file-name">
                <i class="fas fa-check-circle text-success mr-2"></i>
                {{ selectedFileName }}
              </div>

              <!-- File Info Alert -->
              <div class="file-info-alert">
                <div class="info-header">
                  <i class="fas fa-info-circle info-icon"></i>
                  <span class="info-title">Informações do Arquivo</span>
                </div>
                <div class="info-content">
                  <div class="info-item">
                    <span class="info-label">Tamanho máximo:</span>
                    <span class="info-value">10MB</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Formatos aceitos:</span>
                    <span class="info-value">PDF, JPG, JPEG, PNG</span>
                  </div>
                </div>
              </div>

              <div>
                <textarea
                  v-model="description"
                  rows="4"
                  class="form-textarea"
                  placeholder="Descreva o anexo (opcional)..."
                ></textarea>
              </div>
            </div>
          </div>

          <!-- Reading Requirements Section -->
          <div class="form-section">
            <div class="section-header">
              <h4 class="section-title">
                <i class="fas fa-book-reader mr-2"></i>
                Configurações de Leitura
              </h4>
            </div>

            <div class="reading-config">
              <div class="config-group">
                <label class="config-label">
                  Documento será obrigatório para leitura?
                </label>
                <div class="radio-group">
                  <label class="radio-option">
                    <input
                      type="radio"
                      value="0"
                      v-model="required_read"
                      class="radio-input"
                    />
                    <span class="radio-custom"></span>
                    <span class="radio-text">Não</span>
                  </label>
                  <label class="radio-option">
                    <input
                      type="radio"
                      value="1"
                      v-model="required_read"
                      class="radio-input"
                    />
                    <span class="radio-custom"></span>
                    <span class="radio-text">Sim</span>
                  </label>
                </div>
              </div>

              <!-- Attempts Configuration -->
              <div
                v-if="required_read == 1"
                class="config-group attempts-config"
              >
                <label class="config-label">
                  <i class="fas fa-redo-alt mr-1"></i>
                  Quantas vezes será permitido pular?
                </label>
                <v-select
                  v-model="attempts"
                  :items="attemptsOptions"
                  label=""
                  outlined
                  dense
                  class="modern-select attempts-select"
                  hide-details
                />
              </div>
            </div>
          </div>

          <!-- Errors Section -->
          <div v-if="errors.length > 0" class="errors-section">
            <ErrorsMessages :errors="errors" />
          </div>

          <!-- Form Actions -->
          <div class="form-actions">
            <v-btn
              type="submit"
              :disabled="loading"
              class="btn-upload-modern"
              large
            >
              <i class="fas fa-cloud-upload-alt mr-2"></i>
              {{ loading ? "Adicionando..." : "Adicionar Arquivo" }}
            </v-btn>
          </div>
        </form>
      </b-overlay>
    </div>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../../templates/Components/ErrorsMessages";
import api from "../../services/api";
import toast from "../../lib/ToastNotification";
import { userData } from "../../lib/functions";

export default {
  name: "AddDocs",

  components: {
    ErrorsMessages,
  },

  props: {
    folder_id: [Number],
    type_folder: [String],
    resident_id: [Number],
  },

  data() {
    return {
      selectedFiles: [],
      selectedFileName: "",
      loading: false,
      user: null,
      required_read: 0,
      attempts: null,
      description: null,
      errors: [],
      attachments: [],
      attemptsOptions: [
        { text: "0 tentativas", value: 0 },
        { text: "1 tentativa", value: 1 },
        { text: "2 tentativas", value: 2 },
        { text: "3 tentativas", value: 3 },
        { text: "4 tentativas", value: 4 },
        { text: "5 tentativas", value: 5 },
      ],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    userData,

    retrieve() {
      let { user } = userData();
      this.user = user;
    },

    async createDoc(event) {
      try {
        event.preventDefault();
        this.loading = true;

        const {
          folder_id,
          type_folder,
          resident_id,
          required_read,
          description,
        } = this;
        let { attempts } = this;

        if (!this.selectedFiles.length) {
          this.loading = false;
          this.errors = [{ id: 0, message: "Informe pelo menos um anexo" }];
          return;
        }

        if (required_read == 0) {
          attempts = 0;
        }

        if (required_read == 1) {
          if (attempts < 0 || attempts > 5) {
            this.loading = false;
            this.errors = [
              {
                id: this.errors.length,
                message: "Informe a quantidade de tentativas",
              },
            ];
            return;
          }
        }

        const allowedMimes = [
          "image/jpg",
          "image/jpeg",
          "image/pjpeg",
          "image/png",
          "application/pdf",
        ];

        const limitSize = 10 * 1024 * 1024;

        for (const doc of this.selectedFiles) {
          if (!allowedMimes.includes(doc.type)) {
            this.loading = false;
            this.errors = [
              {
                id: this.errors.length,
                message: `Formato inválido: ${doc.name}`,
              },
            ];
            return;
          }

          if (doc.size > limitSize) {
            this.loading = false;
            this.errors = [
              {
                id: this.errors.length,
                message: `${doc.name} excede 10MB`,
              },
            ];
            return;
          }

          const formData = new FormData();

          formData.append("folder_id", folder_id);
          formData.append("type_folder", type_folder);
          formData.append("resident_id", resident_id);
          formData.append("doc", doc, doc.name);
          formData.append("type_doc", doc.type);
          formData.append("required_read", required_read);
          formData.append("attempts", attempts);
          formData.append("description", description);

          const response = await api.post("/folder/doc", formData);

          const { error, errors } = response.data;

          if (error) {
            this.loading = false;
            this.errors = errors;
            return;
          }
        }

        toast("Documentos enviados com sucesso", "success");

        this.errors = [];
        this.selectedFiles = [];
        this.selectedFileName = "";
        document.getElementById("doc").value = "";

        this.$emit("create");
        this.$bvModal.hide("createDoc");

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    onFileChange(event) {
      this.selectedFiles = Array.from(event.target.files);

      this.selectedFileName = this.selectedFiles.length
        ? `${this.selectedFiles.length} arquivo(s) selecionado(s)`
        : "";

      this.errors = [];
    },

    resetForm() {
      this.loading = false;
      this.required_read = 0;
      this.attempts = null;
      this.description = null;
      this.errors = [];
      this.selectedFileName = "";
      if (document.getElementById("doc")) {
        document.getElementById("doc").value = "";
      }
    },
  },
};
</script>

<style scoped>
/* Modal Styling */
.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-title-modern i {
  color: #0f65b0;
}

.modal-content-modern {
  padding: 8px 0;
}

.loading-overlay {
  border-radius: 12px;
}

.selected-file-name {
  margin-top: 12px;
  font-size: 14px;
  color: #1e884d;
  display: flex;
  align-items: center;
  font-weight: 500;
  word-break: break-all;
}

/* Form Styling */
.upload-form {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

/* Form Sections */
.form-section {
  background: #f8fafc;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.section-header {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.section-title i {
  color: #0f65b0;
}

/* Upload Area */
.upload-area {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.file-input-container {
  position: relative;
}

.file-input-label {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0;
}

.file-input-label:hover {
  border-color: #0f65b0;
  background: #f8fafc;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(15, 101, 176, 0.1);
}

.file-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.form-textarea {
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 14px;
  font-family: "WorkSans-Regular", sans-serif;
  background: white;
  transition: all 0.3s ease;
  resize: none;
  min-height: 120px;
}

.form-textarea:focus {
  outline: none;
  border-color: #0f65b0;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
}

.upload-icon {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-right: 20px;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3);
}

.upload-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
}

.upload-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
}

.upload-subtitle {
  font-size: 14px;
  color: #64748b;
}

/* File Info Alert */
.file-info-alert {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  border: 1px solid #60a5fa;
  border-radius: 12px;
  padding: 16px;
}

.info-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.info-icon {
  color: #2563eb;
  margin-right: 8px;
  font-size: 16px;
}

.info-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e40af;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
}

.info-label {
  font-size: 13px;
  font-weight: 500;
  color: #1e40af;
}

.info-value {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  background: rgba(255, 255, 255, 0.7);
  padding: 2px 8px;
  border-radius: 6px;
}

/* Reading Configuration */
.reading-config {
  padding: 24px;
  background: white;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.config-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.config-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0;
  display: flex;
  align-items: center;
}

.config-label i {
  color: #0f65b0;
}

/* Radio Group */
.radio-group {
  display: flex;
  gap: 20px;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  transition: all 0.3s ease;
  margin: 0;
}

.radio-option:hover {
  background: #f8fafc;
}

.radio-input {
  display: none;
}

.radio-custom {
  width: 18px;
  height: 18px;
  border: 2px solid #d1d5db;
  border-radius: 50%;
  position: relative;
  transition: all 0.3s ease;
}

.radio-input:checked + .radio-custom {
  border-color: #0f65b0;
  background: #0f65b0;
}

.radio-input:checked + .radio-custom::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  background: white;
  border-radius: 50%;
}

.radio-text {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

/* Attempts Configuration */
.attempts-config {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

.attempts-select {
  margin-top: 8px;
}

/* Errors Section */
.errors-section {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fca5a5;
  border-radius: 12px;
  padding: 20px;
}

/* Form Actions */
.form-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 8px;
}

.btn-upload-modern {
  background: linear-gradient(135deg, #1e884d 0%, #16a34a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 14px 32px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(30, 136, 77, 0.3) !important;
  transition: all 0.3s ease !important;
  font-size: 14px !important;
}

.btn-upload-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(30, 136, 77, 0.4) !important;
}

.btn-upload-modern:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .upload-form {
    gap: 20px;
  }

  .upload-area,
  .reading-config {
    padding: 16px;
  }

  .file-input-label {
    padding: 24px 16px;
    flex-direction: column;
    text-align: center;
  }

  .upload-icon {
    margin-right: 0;
    margin-bottom: 16px;
    width: 56px;
    height: 56px;
    font-size: 20px;
  }

  .upload-text {
    text-align: center;
  }

  .upload-title {
    font-size: 16px;
  }

  .radio-group {
    flex-direction: column;
    gap: 12px;
  }

  .info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .btn-upload-modern {
    width: 100% !important;
    padding: 12px 24px !important;
  }
}

@media (max-width: 480px) {
  .modal-content-modern {
    padding: 0;
  }

  .section-header {
    padding: 12px 16px;
  }

  .section-title {
    font-size: 14px;
  }

  .upload-title {
    font-size: 14px;
  }

  .upload-subtitle {
    font-size: 12px;
  }

  .file-info-alert {
    padding: 12px;
  }

  .info-title {
    font-size: 13px;
  }

  .info-label,
  .info-value {
    font-size: 12px;
  }
}

/* Override Vuetify styles */
.modern-select >>> .v-input__control {
  border-radius: 8px !important;
}

.modern-select >>> .v-text-field__slot input {
  font-weight: 500 !important;
}

.modern-select >>> .v-input__slot {
  border-color: #e5e7eb !important;
}

.modern-select >>> .v-input--is-focused .v-input__slot {
  border-color: #0f65b0 !important;
  box-shadow: 0 0 0 2px rgba(15, 101, 176, 0.1) !important;
}

/* Modal overrides */
.modern-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  border-bottom: 1px solid #e5e7eb !important;
}

.modern-modal >>> .modal-body {
  padding: 24px !important;
}

.modern-modal >>> .modal-content {
  border-radius: 16px !important;
  border: none !important;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15) !important;
}
</style>